import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=6679d528&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=6679d528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679d528",
  null
  
)

export default component.exports